import { ReactNode, useState } from "react";
import { HeaderContext } from "./useHeaderContext";

export const HeaderProvider = ({ children }: { children: ReactNode }) => {
  const [customBackHandler, setCustomBackHandler] = useState<
    (() => void) | undefined
  >(undefined);
  const [hideBackButton, setHideBackButton] = useState<boolean | undefined>(
    undefined
  );

  return (
    <HeaderContext.Provider
      value={{
        customBackHandler,
        setCustomBackHandler,
        hideBackButton,
        setHideBackButton,
      }}>
      {children}
    </HeaderContext.Provider>
  );
};
